import { Box, Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import AHMIS, { API_URL } from '../../../../api/api';
import AddAlertMessage from '../../../../components/alert/Alert';
import DeleteRegisterRecordConformation from '../../../../components/delete-register-record-conformation/DeleteRegisterRecordConformation';
import CustomModal from '../../../../components/modal/CustomModal';
import NepaliCalender from '../../../../components/nepali-calender';
import RegisterHeader from '../../../../components/register-header/RegisterHeader';
import { AppUtils } from '../../../../utils/appUtils';
import { ERROR, ID, ROW_PER_PAGE, SOMETHING_WENT_WRONG, SUCCESS } from '../../../../utils/constants';
import PhysiotherapySewaBibaranRegister from '../../../users/components/register/physiotherapy-register/helper/PhysiotherapySewaBibaranRegister';

const PhysiotherapySewaBibaranForm = () => {
  const [modalTitle, setModalTitle] = useState("अकुपञ्चर सेवा सेवा विवरण रजिष्टर नयाँ रेकर्ड थप्नुहोस्");
  const [showPhysiotherapyBibaranModal, setShowPhysiotherapyBibaranModal] = useState(false);
  const [modalDefaultValues, setModalDefaultValues] = useState();
  const [physiotherapyBibaranSewaBibaranTableData, setPhysiotherapyBibaranSewaBibaranTableData] = useState([]);
  const [getTableData, setGetTableData] = useState(false);
  const { register, handleSubmit, setValue, formState: { errors }, reset } = useForm();
  const [showPhysiotherapyBibaranDeleteModal, setShowPhysiotherapyBibaranDeleteModal] = useState(false);
  const [page, setPage] = useState(0);
  const [totalSize, setTotalSize] = useState(0);
  const [physiotherapyBibaranDeleteId, setPhysiotherapyBibaranDeleteId] = useState(null);
  const physiotherapyRegisterId = AppUtils.getUrlParam(ID);
  const { fromDate, toDate, searchParams } = useSelector((state) => state.dateReducer);
  const { rowsPerPage, pageNumber } = useSelector((state) => state.searchFilter);

  useEffect(() => {
    showPhysiotherapyBibaranModal && reset();
  }, [reset, showPhysiotherapyBibaranModal]);

  const openPhysiotherapyBibaranModal = () => {
    setShowPhysiotherapyBibaranModal(true);
  };

  const closePhysiotherapyBibaranModal = () => {
    setShowPhysiotherapyBibaranModal(false);
    setModalDefaultValues();
    reset();
  }

  useEffect(() => {
    register("sewaCode");
  }, [register]);

  const handleDateChange = (name, dateInMilli) => {
    setValue(name, dateInMilli);
  };

  const submitPhysiotherapyBibaranRegister = (data) => {
    if (modalDefaultValues?.id) {
      data.id = modalDefaultValues.id;
    }
    const url = `${API_URL.physiotherapySewaService}?physiotherapyServiceRegistrationId=${physiotherapyRegisterId}`;
    AHMIS.post(url, data)
      .then(response => {
        if (response.data.type === SUCCESS) {
          closePhysiotherapyBibaranModal();
          setGetTableData(true);
        }
        AddAlertMessage({ type: response.data.type, message: response.data.message });
      })
      .catch(error => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      });
  }

  useEffect(() => {
    if (fromDate && toDate) {
      getPhysiotherapyBibaranSewa(fromDate, toDate, searchParams)
    }
  }, [fromDate, toDate, searchParams, getTableData, rowsPerPage, pageNumber])

  const getPhysiotherapyBibaranSewa = (fromDate, toDate, searchParams, healthClientId, pageFromParam) => {
    let url = `${API_URL.physiotherapySewaService}/fromDateRangeAndPage?fromDate=${fromDate}&toDate=${toDate}&pageNumber=${pageNumber}&rowSize=${rowsPerPage}&physiotherapyServiceRegistrationId=${physiotherapyRegisterId}`;
    if (healthClientId) {
      url = url + "&healthClientId=" + healthClientId;
    }
    if (searchParams) {
      url = url + "&searchParam=" + searchParams;
    }
    AHMIS.get(url)
      .then(response => {
        let jsondata = response.data;
        setPhysiotherapyBibaranSewaBibaranTableData(jsondata?.data?.objectList || []);
        setGetTableData(false);
        setTotalSize(jsondata?.data?.totalSize)
      })
      .catch(error => {
        AddAlertMessage({ type: "error", message: SOMETHING_WENT_WRONG });
      });
  }

  const physiotherapyBibaranSewaEdit = (id) => {
    AHMIS.get(API_URL.physiotherapySewaService + "/" + id)
      .then(response => {
        setModalDefaultValues(response.data?.data);
        setShowPhysiotherapyBibaranModal(true);
      }).catch(error => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      })
  }

  const closePhysiotherapyBibaranDeleteModal = () => {
    setShowPhysiotherapyBibaranDeleteModal(false);
    setPhysiotherapyBibaranDeleteId(null);
  }

  const onDeletePhysiotherapyBibaranRow = (id) => {
    setShowPhysiotherapyBibaranDeleteModal(true);
    setPhysiotherapyBibaranDeleteId(id);
  }

  const deletePhysiotherapyBibaranSewaRow = (data) => {
    AHMIS.delete(API_URL.physiotherapySewaService + "/" + physiotherapyBibaranDeleteId + "?deleteReason=" + data.deletedReason)
      .then(response => {
        let jsondata = response.data;
        if (jsondata.type === SUCCESS) {
          setShowPhysiotherapyBibaranDeleteModal(false);
          setPhysiotherapyBibaranDeleteId(null);
          AddAlertMessage({ type: jsondata.type, message: jsondata.message });
          setGetTableData(true);
        } else {
          AddAlertMessage({ type: jsondata.type, message: jsondata.message });
        }
      })
      .catch(error => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      });
  }

  const onHeaderParamChange = (fromDate, toDate, searchParam, healthClientId) => {
    setPage(0)
    getPhysiotherapyBibaranSewa(fromDate, toDate, searchParam, healthClientId, 1);
  }

  const handleChangePage = (newPage) => {
    setPage(newPage);
    setGetTableData(true);
  };

  return (
    <>
      <Box marginTop={2}>
        <RegisterHeader
          registerTitle="फिजियोथेरापी सेवा रजिष्टर सेवा विवरण "
          handleModalOpen={openPhysiotherapyBibaranModal}
          getRegisterData={getPhysiotherapyBibaranSewa}
          onHeaderParamChange={onHeaderParamChange}
          getTableData={getTableData}
          fromDateDefaultFormat
          lazyLoading
          showSearchField
        />
      </Box>
      <CustomModal
        title={modalTitle}
        showModal={showPhysiotherapyBibaranModal}
        onModalSubmit={handleSubmit(submitPhysiotherapyBibaranRegister)}
        onModalClose={closePhysiotherapyBibaranModal}
        maxWidth="lg"
        fullScreen
      >
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={6} md={3}>
            <NepaliCalender
              id="Dates"
              label="मिति"
              name="dartaaMiti"
              defaultDate={modalDefaultValues?.dartaaMiti}
              onChange={handleDateChange}
            />
          </Grid>
        </Grid>
      </CustomModal>
      <DeleteRegisterRecordConformation
        showDeleteModal={showPhysiotherapyBibaranDeleteModal}
        closeDeleteModel={closePhysiotherapyBibaranDeleteModal}
        deleteRecord={deletePhysiotherapyBibaranSewaRow}
      />
      <PhysiotherapySewaBibaranRegister
        onEditRow={physiotherapyBibaranSewaEdit}
        tableData={physiotherapyBibaranSewaBibaranTableData}
        deleteRow={onDeletePhysiotherapyBibaranRow}
        page={page}
        handleChangePage={handleChangePage}
        totalSize={totalSize}
        getTableData={(value) => setGetTableData(value)}
      />
    </>
  )
}

export default PhysiotherapySewaBibaranForm;
